import React from 'react'
// import PropTypes from 'prop-types'
import { StyledButton as Button } from '../../common/Button'
import Icon, { FolderIcon } from 'common/components/Icon'
import Text from 'common/components/Text'
import Menu from '../../common/Menu'
import { StyledFormElement as FormElement } from '../../common/FormElement'
import { MoveMenuLevelContainer } from './MoveMenuContainer'
import { EDITOR } from '../../../constants'

export const MoveMenuLevelBase = ({
  storeRef,
  style,
  subfolders,
  hasChildren,
  t,
  ...props
}) => {
  const firstLevel = props.path.length === 1
  const moveItem = props.moveItem
  return (
    <Menu innerRef={storeRef} style={style}>
      {/* First level of menu gets "No folder" as an extra option */}
      {firstLevel && (
        <>
          <Button onClick={() => moveItem(null)}>
            {t('globalNav.noFolder')}
          </Button>
          <Menu.Divider />
        </>
      )}

      {subfolders.map(subfolder => {
        return (
          <MoveMenuLevel {...props} folderId={subfolder.id} key={subfolder.id}>
            {({ ref, ...props }) =>
              subfolder.accessLevel >= EDITOR ? (
                <Button
                  onClick={() => moveItem(subfolder.id)}
                  innerRef={ref}
                  {...props}
                >
                  <FolderIcon color={subfolder.color} />
                  <Text>{subfolder.name}</Text>
                  <FormElement.Spacer />
                  {hasChildren(subfolder.id) && <Icon icon="arrowhead-right" />}
                </Button>
              ) : (
                <FormElement innerRef={ref} {...props}>
                  <FolderIcon color={subfolder.color} />
                  <Text bold grey>
                    {subfolder.name}
                  </Text>
                  <FormElement.Spacer />
                  <Icon icon="arrowhead-right" />
                </FormElement>
              )
            }
          </MoveMenuLevel>
        )
      })}
    </Menu>
  )
}

// MoveMenuLevel.propTypes = {
//   item: PropTypes.object.isRequired
// }

const MoveMenuLevel = MoveMenuLevelContainer(MoveMenuLevelBase)
export default MoveMenuLevel
